import { render, staticRenderFns } from "./ConfirmationBuy.vue?vue&type=template&id=f5b38fdc&scoped=true&"
import script from "./ConfirmationBuy.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationBuy.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationBuy.vue?vue&type=style&index=0&id=f5b38fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b38fdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
